<template>
  <div class="header basic-padding-left-right" :class="showDarkTheme?'header-dark':''">
    <div class="header-left">
      <img src="@/static/images/logo3.png">
      <div class="changeLo-btn" @click="changeLo">
        {{ $t('menu.menuName', { menuName: $i18n.locale==='en' ? '中文' :  'English' }) }}
      </div>
    </div>
    <div class="header-right">
      <div class="header-right-item" v-for="(item,index) in list" :key="index" :class="item.selected?'header-right-item-selected':''" @mouseenter="showSubMenuFun(item.type,item.engName)"  @mouseleave="closeMenu" @click="jumpTo(item)">
        {{ $t('menu.menuName', { menuName: $i18n.locale==='en' ? item.engName :  item.name }) }}
        <div v-if="item.type==='hover'" class="sub-menu" :class="showSubMenu?'sub-menu-active':''">
          <div class="sub-menu-item" @click.stop="subMenuJumpTo('/solution/tongsuanCloud',1)">{{ $t('subMenu.subItem2') }}</div>
            <div class="sub-menu-item" @click.stop="subMenuJumpTo('/solution/tongyijia',1)">{{ $t('subMenu.subItem1') }}</div>
            <div class="sub-menu-item" @click.stop="subMenuJumpTo('/solution/functionalAdditives',1)">{{ $t('subMenu.subItem3') }}</div>
        </div>
        <div v-if="item.type==='hover2'" class="sub-menu" :style="{width:$i18n.locale==='en' ?'210px':'160px'}" :class="showSubMenu2?'sub-menu-active2':''">
          <div class="sub-menu-item" @click.stop="subMenuJumpTo('/development/innovation',2)">{{ $t('subMenu.itemName',{ itemName: $i18n.locale==='en' ? 'Innovation & Technology' :  '创新技术' }) }}</div>
          <div class="sub-menu-item" @click.stop="subMenuJumpTo('/development/breakthroughs',2)">{{ $t('subMenu.itemName',{ itemName: $i18n.locale==='en' ? 'R&D Breakthroughs' :  '研发突破' }) }}</div>
        </div>

      </div>
    </div>
  </div>
<!--  <div>-->
<!--    <p>{{ $t('hello') }}</p>-->
<!--    <p>{{ $t('greetings.hello', { name: 'John' }) }}</p>-->
<!--    <p>{{ $t('welcome') }}</p>-->
<!--  </div>-->
<!--  <div @click="changeLocale">{{$i18n.locale === 'en' ? '中文' : 'English'}}</div>-->
</template>
<script>
export default {
  name: 'Header',
  data() {
    return {
      list:[{
        name:"首页",
        engName:"Home",
        selected:true,
        path:"/",
        pathName:"home"
      },{
        name:"解决方案",
        engName:"Solution",
        type:"hover",
        selected:false,
        path:"/",
        pathName:"solution"
      },{
        name:"研发",
        engName:"Development",
        type:"hover2",
        selected:false,
        path:"/",
        pathName:"development"
      },{
        name:"品牌",
        engName:"Brand",
        selected:false,
        path:"/brand/index",
        pathName:"brand"
      },{
        name:"新闻中心",
        engName:"News",
        selected:false,
        path:"/newsAndEvents/index",
        pathName:"newsAndEvents"
      },{
        name:"关于我们",
        engName:"About",
        selected:false,
        path:"/about",
        pathName:"about"
      }],
      showSubMenu:false,
      showSubMenu2:false,
      scrollContainer: null,
      showDarkTheme:false,

    }
  },
  watch: {
    $route(to, from) {
      console.log('Route changed to:', to.path);
      this.list.forEach((item,index)=>{
        if(to.path.includes(item.pathName)){
          this.list[index].selected = true;
        }else{
          this.list[index].selected = false;
        }
      })
      this.list.forEach((item,index)=>{
        let menuState = this.list.some(listItem=>listItem.selected)
        if(!to.path.includes(item.pathName)&&!menuState){
          this.list[0].selected = true;
        }
      })
    }
  },
  mounted() {
    // 获取滚动容器（这可能是 window 或某个具有滚动条的元素）
    this.scrollContainer = window;
    // 监听滚动事件
    this.scrollContainer.addEventListener('scroll', this.handleScroll);
  },
  methods:{
    closeMenu(){
      this.showSubMenu = false;
      this.showSubMenu2 = false;
    },
    jumpTo(item){
      if(item.type==="hover"||item.type==="hover2") return;
      this.list.forEach(listItem=>{
        listItem.selected = false;
      })
      item.selected = true;
      if(item.path!==this.$router.currentRoute.path){
        this.$router.push(item.path)
      }

    },
    changeLo(){
      this.$i18n.locale = this.$i18n.locale === 'en' ? 'zh' : 'en';
    },
    subMenuJumpTo(path,index){
      console.log(path,"subMenu跳转")
      if(path!==this.$router.currentRoute.path){
        this.$router.push(path)
      }
      this.list.forEach(listItem=>{
        listItem.selected = false;
      })
      this.list[index].selected = true
    },
    showSubMenuFun(type,name){
      if(type==='hover'){
        this.showSubMenu = true;
      }
      if(type==='hover2'){
        this.showSubMenu2 = true;
      }
    },
    handleScroll() {
      // 获取当前滚动位置
      const scrollPosition = window.scrollY || window.scrollTop || document.documentElement.scrollTop;

      // 如果滚动位置超过指定像素值阈值
      if (scrollPosition > 550) {
        // 执行你想要触发的方法
        console.log("超过指定像素值")
        return this.showDarkTheme = true;
      }else{
        return this.showDarkTheme = false;
      }
    },

  },
  beforeDestroy() {
    // 在组件销毁前移除滚动事件监听器
    window.removeEventListener('scroll', this.handleScroll);
  }
}
</script>
<style lang="less" scoped>
.header{
  width: 100%;
  height: 70px;
  background: rgba(216,216,216,0);
  box-shadow: 0px 1px 0px 0px rgba(244,244,244,0.18);
  border-bottom: 1px solid rgba(244, 244, 244, 0.2);
  position: fixed;
  box-sizing: border-box;
  backdrop-filter: blur(3px);
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-weight: 400;
  font-size: 16px;
  z-index: 999;
  user-select: none;

  .header-left{
    display: flex;
    align-items: center;
    .changeLo-btn{
      width: 85px;
      height: 25px;
      border-radius: 12px;
      border: 1px solid #FFFFFF;
      opacity: 0.67;
      font-weight: 600;
      font-size: 12px;
      color: #FFFFFF;
      display: flex;
      align-items: center;
      justify-content: center;
      margin-left: 25px;
      cursor: pointer;
    }
    img{
      width: 130px;
      height: 35px;
      transform: scale(1.4);
    }
  }
  .header-right{
    display: flex;
    .header-right-item{
      width: 120px;
      height: 70px;
      display: flex;
      align-items: center;
      justify-content: center;
      color: rgba(255, 255, 255, 0.75);
      cursor: pointer;
      position: relative;
      .sub-menu{
        width: 180px;
        transition: height 0.2s; /* 2 秒内完成高度变化 */
        height: 0;
        background: rgba(62, 64, 72, 0.5);
        border-radius: 8px;
        position: absolute;
        left: 50%;
        transform: translateX(-50%);
        top: 80px;
        overflow: hidden;
        display: flex;
        flex-direction: column;
        justify-content: space-around;
        box-sizing: border-box;
        .sub-menu-item{
          width: 100%;
          padding-left: 30px;
          display: flex;
          align-items: center;
          color: rgba(255, 255, 255, 0.75);
          font-weight: 400;
          font-size: 14px;
        }
        .sub-menu-item:hover{
          color: #ffffff;
        }
      }
      .sub-menu-active{
        height: 160px;
      }.sub-menu-active2{
        height: 130px;

      }

    }
    .header-right-item-selected{
      color: #ffffff;
    }
  }
}
.header-dark{
  background: black;
}

</style>